import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "privacy__wrapper"
}
const _hoisted_4 = { class: "privacy__header" }
const _hoisted_5 = { class: "privacy__header-title" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = ["aria-label", "innerHTML"]
const _hoisted_8 = { class: "modal" }
const _hoisted_9 = { class: "modal__title" }
const _hoisted_10 = ["aria-label", "innerHTML"]
const _hoisted_11 = ["aria-label"]

import { Ref, ref, onMounted, computed, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import AppNav from "@/components/AppNav.vue";

import { config, dictionary } from "./constants";
import { useSetDocumentTitle } from "./composables";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const store = useStore();
const setDocumentTitle = useSetDocumentTitle();

const resizeId: Ref<null | number> = ref(null);
const preventScrolling: Ref<boolean> = ref(false);
const animateOnLoad: Ref<boolean> = ref(false);
const privacyModalOpen: Ref<boolean> = ref(false);

const modalClose = ref(null);
const modalWrapper = ref(null);

const routeKey = computed(function () {
  return route.name === "results" || route.name === "choices-overview"
    ? "results"
    : route.path;
});

const contentAnimation = computed(function () {
  if (animateOnLoad.value) {
    if (config.settings.showAd) {
      return `content-slide-with-ad-${store.getters.direction}`;
    } else {
      return `content-slide-${store.getters.direction}`;
    }
  } else {
    return "fade";
  }
});

function calculateHeight(): void {
  document.documentElement.style.setProperty(
    "--vh",
    `${window.innerHeight * 0.01}px`,
  );
}
function closePrivacy(): void {
  store.dispatch("seenPrivacyStatement");
}
function closePrivacyModal(e: any): void {
  if (e.target.classList.contains("modal__wrapper")) {
    privacyModalOpen.value = false;
  }
}

watch(route, () => {
  setDocumentTitle();
  if (route.name === "start" && store.getters.showPrivacyStatement)
    closePrivacy();
});

// 	used to be in created()
calculateHeight();

window.addEventListener("resize", () => {
  if (resizeId.value) {
    clearTimeout(resizeId.value);
  }
  resizeId.value = setTimeout(calculateHeight, 500);
});
window.addEventListener("popstate", () => {
  setDocumentTitle();
});

document.addEventListener("keyup", (e: any) => {
  if (e.code === "Escape") privacyModalOpen.value = false;
  if (e.code === "Tab" && privacyModalOpen) {
    e.preventDefault();

    if (modalWrapper.value && modalClose.value) {
      if (
        !(modalWrapper.value as unknown as HTMLElement).contains(
          document.activeElement,
        )
      )
        (modalClose.value as unknown as HTMLElement).focus();
    }
  }
});

setDocumentTitle();
if (config.settings.showAd) {
  document.body.classList.add("with-ad");
}
////

onMounted(() => {
  setTimeout(() => {
    animateOnLoad.value = true;
  }, 150);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app", {
      'with-ad': _unref(config).settings.showAd && _unref(route).name !== 'embed',
      'app--white': _unref(route).name !== 'start',
      'app--prevent-scrolling': preventScrolling.value,
    }])
  }, [
    (_unref(route).name !== 'embed')
      ? (_openBlock(), _createBlock(AppNav, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, {
      class: "app__content",
      onPreventScrolling: _cache[0] || (_cache[0] = ($event: any) => (preventScrolling.value = true)),
      onAllowScrolling: _cache[1] || (_cache[1] = ($event: any) => (preventScrolling.value = false)),
      onOpenPrivacyModal: _cache[2] || (_cache[2] = ($event: any) => (privacyModalOpen.value = true))
    }, {
      default: _withCtx(({ Component }) => [
        _createVNode(_Transition, {
          mode: "out-in",
          name: contentAnimation.value
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { key: routeKey.value }))
          ]),
          _: 2
        }, 1032, ["name"])
      ]),
      _: 1
    }),
    (
        _unref(config).settings.showAd &&
        _unref(config).settings.desktopAdCode &&
        _unref(route).name !== 'embed'
      )
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "app__ad",
          innerHTML: _unref(config).settings.desktopAdCode
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    (
        _unref(config).settings.showAd &&
        _unref(config).settings.mobileAdCode &&
        _unref(route).name !== 'embed'
      )
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "app__ad app__ad--mobile",
          innerHTML: _unref(config).settings.mobileAdCode
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      name: 
        _unref(config).settings.showAd
          ? 'slide-right-mobile-down-with-ad'
          : 'slide-right-mobile-down'
      
    }, {
      default: _withCtx(() => [
        (
          _unref(store).getters.showPrivacyStatement &&
          animateOnLoad.value &&
          _unref(route).name !== 'embed'
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("header", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(dictionary).app.privacy.title), 1),
                _createElementVNode("button", {
                  class: "privacy__close",
                  "aria-label": _unref(dictionary).app.closeModal,
                  tabindex: "0",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (closePrivacy()))
                }, _toDisplayString(_unref(dictionary).app.closeModal), 9, _hoisted_6)
              ]),
              _createElementVNode("div", {
                class: "privacy__text",
                "aria-label": 
            _unref(dictionary).app.accessibility.privacy.text
              ? _unref(dictionary).app.accessibility.privacy.text
              : _unref(dictionary).app.privacy.text
          ,
                innerHTML: _unref(dictionary).app.privacy.text
              }, null, 8, _hoisted_7),
              (_unref(dictionary).app.privacy.modalText)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "privacy__button button button--white",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (privacyModalOpen.value = true))
                  }, _toDisplayString(_unref(dictionary).app.privacy.button), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["name"]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (privacyModalOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "modal__wrapper",
              ref_key: "modalWrapper",
              ref: modalWrapper,
              onClick: closePrivacyModal
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h3", _hoisted_9, _toDisplayString(_unref(dictionary).app.privacy.title), 1),
                _createElementVNode("div", {
                  class: "modal__content text",
                  "aria-label": 
              _unref(dictionary).app.accessibility.privacy.modalText
                ? _unref(dictionary).app.accessibility.privacy.modalText
                : _unref(dictionary).app.privacy.modalText
            ,
                  innerHTML: _unref(dictionary).app.privacy.modalText
                }, null, 8, _hoisted_10),
                _createElementVNode("button", {
                  class: "privacy__close privacy__close--black",
                  ref_key: "modalClose",
                  ref: modalClose,
                  "aria-label": _unref(dictionary).app.closeModal,
                  tabindex: "0",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (privacyModalOpen.value = false))
                }, _toDisplayString(_unref(dictionary).app.closeModal), 9, _hoisted_11)
              ])
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}
}

})